import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BGX_CONFIG, BgxConfigService } from './config.service';

@NgModule({
  imports: [RouterModule],
  providers: [BgxConfigService],
})
export class BgxConfigModule {
  static forRoot(config): ModuleWithProviders {
    return {
      ngModule: BgxConfigModule,
      providers: [
        {
          provide: BGX_CONFIG,
          useValue: config,
        },
      ],
    };
  }
}
